import { useEffect } from "react";
import { useLocation } from "@tanstack/react-router";
import FloatingNav from "./FloatingNav";
import PageNav from "./PageNav";
import Footer from "./Footer";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  const isHome = pathname === "/";

  return (
    <div className="flex flex-col min-h-screen">
      <FloatingNav sticky={!isHome} />
      {!isHome && <PageNav />}
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
